/**
 * Carte « Automatismes » du tableau de bord élève (migration 0323) : lancer /
 * reprendre une série de 10 questions flash, dernier score, séries encore
 * récompensées en HORA aujourd'hui. Gratuit : 1 série par mois (migration
 * 0339) — une fois faite, cadenas vers la page qui propose de débloquer.
 */

import { Link } from '@tanstack/react-router';
import { Lock, Play, Zap } from 'lucide-react';
import { HelpTip } from '@/components/help-tip';
import {
  automatismesAccessLine,
  automatismesCta,
  automatismesLocked,
  rewardsLeftToday,
  type AutomatismesState,
} from '@/lib/automatismes';

export function AutomatismesCard({ state }: { state: AutomatismesState | undefined }) {
  if (!state?.available) return null;
  const left = rewardsLeftToday(state);
  const last = state.last?.score_pct;
  const locked = automatismesLocked(state);
  const accessLine = automatismesAccessLine(state);
  return (
    <section
      aria-labelledby="automatismes-title"
      className="border-primary-200 bg-primary-50/60 ocean:bg-white/5 flex items-center gap-3 rounded-2xl border p-4"
    >
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <span className="bg-accent-500 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-white">
          <Zap className="h-5 w-5" aria-hidden />
        </span>
        <div className="min-w-0">
          <h2
            id="automatismes-title"
            className="font-display text-ink-900 flex items-center text-base font-bold"
          >
            Automatismes
            <HelpTip topic="automatismes" label="Automatismes" />
          </h2>
          <p className="text-ink-600 text-sm">
            {state.in_progress
              ? `Série en cours : ${state.in_progress.answered_count}/${state.in_progress.question_count}.`
              : '10 questions flash, sans calculatrice, sur tout ce que tu as déjà vu.'}
          </p>
          <p className="text-ink-500 text-xs">
            {left > 0
              ? `+XP +HORA · ${left}/${state.daily_reward_limit ?? 3} séries récompensées restantes aujourd’hui`
              : 'HORA du jour gagnée : entraînement libre (+XP)'}
            {typeof last === 'number' ? ` · dernier score ${last} %` : ''}
          </p>
          {accessLine && (
            <p
              className={locked ? 'text-accent-600 text-xs font-semibold' : 'text-ink-500 text-xs'}
            >
              {accessLine}
            </p>
          )}
        </div>
      </div>
      <Link
        to="/student/automatismes"
        aria-label={automatismesCta(state)}
        title={automatismesCta(state)}
        className={
          locked
            ? 'border-ink-200 text-ink-700 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border bg-white shadow-md active:scale-[0.95]'
            : 'bg-primary-600 hover:bg-primary-700 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white shadow-md active:scale-[0.95]'
        }
      >
        {locked ? (
          <Lock className="h-5 w-5" aria-hidden />
        ) : (
          <Play className="ml-0.5 h-5 w-5 fill-current" aria-hidden />
        )}
      </Link>
    </section>
  );
}
